<template>
  <div class="zcsx-entry-container">
    <ucar-title toApp="www.baidu.com">司机招募</ucar-title>
    <div class="zcsx-tab-wrap">
      <div @click="isZCEntry = true">
        <div :class="{ 'zcsx-tab-selected': isZCEntry }">专车</div>
      </div>
      <div @click="isZCEntry = false" v-if="isShowSX">
        <div :class="{ 'zcsx-tab-selected': !isZCEntry }">舒享</div>
      </div>
    </div>
    <div class="zcsx-content-wrap">
      <img :src="require(`../../assets/${ isZCEntry ? 'zc' : 'sx'}-poster.png`)" alt="" />
      <div class="zcsx-entry">
        <p>
          <b>{{ isZCEntry ? '专车准入标准' : '舒享准入标准' }}</b>
        </p>
        <ul v-if="isZCEntry">
          <li v-for="(item, index) in translateStr(driverRequire)" :key="index">
            {{ item }}
          </li>
        </ul>
        <ul v-else>
          <li
            v-for="(item, index) in translateStr(comfortDriverRequire)"
            :key="index"
          >
            {{ item }}
          </li>
        </ul>
      </div>
      <div class="car-entry">
        <p>
          <b>车辆准入标准</b>
        </p>
        <ul v-if="isZCEntry">
          <li v-for="(item, index) in translateStr(carRequire)" :key="index">
            {{ item }}
          </li>
        </ul>
        <ul v-else>
          <li
            v-for="(item, index) in translateStr(comfortVehicleRequire)"
            :key="index"
          >
            {{ item }}
          </li>
        </ul>
      </div>
    </div>
    <div class="zcsx-btn-wrap">
      <button
        type="button"
        class="btn-submit app-btn-submit"
        :class="{ 'app-btn-submit-enable': enableSubmit }"
        @click="handleBtnClick"
      >
        加入我们
      </button>
    </div>
  </div>
</template>

<script>
import { routeToDoList } from '../../utils/jsBridge/jsBridge.js'
import { getEnlist, getCityConfig, getDriverConfig, changeIdentity } from '../../api.js'
export default {
  data() {
    return {
      isZCEntry: true, // true 专车 false 舒享
      enableSubmit: true,
      driverRequire: '', // 专车准入
      carRequire: '', // 专车车辆
      comfortDriverRequire: '',
      comfortVehicleRequire: '',
      enlistId: '',
      serviceCityId: 0,
      identityFlag: 1,
      sex: 0,
      age: 0,
      isShowSX: 1, // 是否开启舒享，若关闭则只显示专车tab   1-开启，0-关闭
    }
  },
  methods: {
    async getBaseData() {
      let enlistRes = await getEnlist({ enlistId: this.enlistId })
      const { serviceCityId, identityFlag, sex, age } = enlistRes
      this.serviceCityId = serviceCityId
      this.identityFlag = identityFlag
      this.sex = sex
      this.age = age
      // this.isZCEntry = identityFlag === 1
      const res = await getCityConfig({ serviceCityId })
      this.driverRequire = res.driverRequire
      this.carRequire = res.vehicleRequire
      this.comfortDriverRequire = res.comfortDriverRequire
      this.comfortVehicleRequire = res.comfortVehicleRequire
      this.isShowSX = res.enableComfort
      if(isShowSX){
        this.isZCEntry = false
      } else {
        this.isZCEntry = true
      }
    },

    async handleBtnClick() {
      let { isZCEntry, serviceCityId, identityFlag, enlistId, age, sex } = this
      const preIsZC = identityFlag === 1
      const currIdentityFlag = isZCEntry ? 1 : 2
      console.log(preIsZC, isZCEntry, identityFlag, preIsZC !== isZCEntry);
      if (preIsZC !== isZCEntry) {
        this.$alert({
          type: 'confirm',
          dsc: `您之前选择的是${preIsZC ? '专车' : '舒享'}司机，是否更换加入${isZCEntry ? '专车' : '舒享'}司机`,
          showCancel: true,
          center: true,
          okText: `加入${isZCEntry ? '专车' : '舒享'}`,
          cancelText: '取消',
          callback: async () => {
            const res = await getDriverConfig({ serviceCityId, identityFlag: currIdentityFlag })
            // const res = { minAgeMan: 0, maxAgeMan: 99, minAgeWoMan: 1, maxAgeWoMan: 100 }
            //  if (!isZCEntry || (isZCEntry && (sex === 1 && res.minAgeMan <= age && age <= res.maxAgeMan) || (sex === 0 && res.minAgeWoman <= age && age <= res.maxAgeWoman))) {
            // 专车舒享同样要判断年龄 
            if ((sex === 1 && res.minAgeMan <= age && age <= res.maxAgeMan) || (sex === 0 && res.minAgeWoman <= age && age <= res.maxAgeWoman)) {
              const identityRes = await changeIdentity({ enlistId, identityFlag: currIdentityFlag })
              if (identityRes.code === 0) {
                routeToDoList(currIdentityFlag)
              }
            } else {
              this.$alert(`您的年龄不符合${currIdentityFlag==1 ? '专车' : '舒享'}准入要求，很遗憾！请加入${currIdentityFlag==1? '舒享' : '专车'}身份，成为${currIdentityFlag==1? '舒享' : '专车'}一员！`)
            }
          }
        })
      } else {
        routeToDoList(currIdentityFlag)
       }
    },

    translateStr(str) {
      return str.split('\n').filter(item => !!item.replace(/\s/g, ''))
    },
  },
  mounted() {
    // 调试
    // this.enableSubmit = true
    this.enlistId = this.$route.query.enlistId
    this.getBaseData()
  },
}
</script>

<style lang="stylus" scoped>
@import '../../styles/variable.styl';

.zcsx-tab-wrap {
  display: flex;
  position: fixed;
  align-items: center;
  top: 88px;
  width: 100%;
  height: 88px;
  background-color: #313339;

  > div {
    padding: 0 140px;
    font-size: 28px;
    line-height: 88px;
    text-align: center;
    flex: 1;
  }
}

.zcsx-tab-selected {
  border-bottom: 6px solid #FA9616;
  color: #FA9616;
}

.zcsx-content-wrap {
  margin-top: 176px;
}

.zcsx-entry, .car-entry {
  padding: 40px;
  margin-bottom: 30px;
  background-color: #fff;

  > p {
    text-align: center;
    font-size: 32px;
    color: #333;
  }

  > ul {
    margin-top: 40px;
    font-size: 28px;
    line-height: 52px;
  }

  > ul li {
    list-style: disc outside;
  }
}

.car-entry {
  margin-bottom: 188px;
}

.zcsx-btn-wrap {
  position: fixed;
  bottom: 0;
  width: 100%;
  box-sizing: border-box;
  background-color: #FAFAFA;
  padding: 20px 30px 80px;
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.2);
  border: 2px solid #EFEFEF;
}
</style>
